export default __webpack_public_path__ + "static/media/activity-1.5f55af05.png";